/**
 * User-facing complaint serial (ticket number, falling back to id).
 *
 * New complaints always get a sequential ``ticket_number``. Older
 * rows may still have a blank or hex ticket; the UI then shows the id,
 * which is what staff already treated as the serial (1, 2, 3, …).
 */
export function complaintSerial(complaint) {
  if (!complaint) return '';
  return complaint.serial_number || complaint.ticket_number || complaint.id || '';
}
